import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class RailPointService {
  constants: Constants = new Constants();
  
  constructor(private readonly http: HttpClient) { }

  getDetails(fiscalYear): Observable<any> {
    const httpCustomOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    };
    return this.http
      .get(this.constants.getApiBasePath() + `/api/v1/getrailpoints?fiscalYear=${fiscalYear}`, httpCustomOptions)
      .pipe(
        tap(_ => this.log('data success')),
        catchError(this.handleError<any>('data fails'))
      );
  }

  addRailPoint(arrData: any): Observable<any> {
		const headers = new HttpHeaders().set('Content-Type', 'application/json');
		return this.http
			.post(this.constants.getApiBasePath() + '/api/v1/railpoints/add', arrData, { headers, responseType: 'text' })
			.pipe(
				tap(_ => this.log('data inserted success')),
				catchError(this.handleError<any>('data insert failed'))
			);
	}

  deleteRailPoint(arrData: any): Observable<any> {
		return this.http
			.delete(this.constants.getApiBasePath() + `/api/v1/railpoints/delete/${arrData.railPointID}`)
			.pipe(
				tap(_ => this.log('data delete success')),
				catchError(this.handleError<any>('data delete failed'))
			);
	}

  editRailPoint(arrData: any): Observable<any> {
    console.info("Entered editRailPoint()");
		const headers = new HttpHeaders().set('Content-Type', 'application/json');
		return this.http
			.put(this.constants.getApiBasePath() + `/api/v1/railpoints/update`, arrData, { headers, responseType: 'text' })
			.pipe(
				tap(_ => this.log('data update success')),
				catchError(this.handleError<any>('data update failed'))
			);
  }

  private handleError<T>(_operation, result?: T) {
    return (error: any): Observable<T> => {
      console.info(error); // log to console instead
      return of(result as T);
    };
  }

  /** Log a message */
  private log(message: string) {
    console.info('Message: ' + message);
  }
}
